import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Duration from 'components/Duration';

// We don't need to add an extra screen-reader friendly
// aria-label as the regular readout is already readable.
// Adding the label leads to a double announcement.
var noLabel = function noLabel() {
  return null;
};
function FriendlyDuration(_ref) {
  var value = _ref.value;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Duration, {
    value: value,
    getLabel: noLabel
  }, function (_ref2) {
    var hours = _ref2.hours,
      minutes = _ref2.minutes;
    var localisedHours = t('hour_short', {
      count: hours
    });
    var localisedMinutes = t('minute_short', {
      count: minutes
    });
    if (hours === 0) {
      return localisedMinutes;
    }
    if (minutes === 0) {
      return localisedHours;
    }
    return "".concat(localisedHours, " ").concat(localisedMinutes);
  });
}
export default FriendlyDuration;